import React from 'react'
import '../../styles/_Contact.css'
import { Col } from 'react-bootstrap'
import { addMessage } from '../../actions/actions'
// import cvespaniol from '../../store/Milagros_Rodriguez_CoronadoES.pdf'
// import resumeenglish from '../../store/Milagros_Rodriguez_CoronadoEN.pdf'
import cvespaniol from '../../store/Milagros_Rodriguez_C_ES.pdf'
import resumeenglish from '../../store/Milagros_Rodriguez_C_EN.pdf'

export const ContactInfo = ({isSpanish}) => {
  return (
    <Col lgOffset={1} mdOffset={1} lg={5} md={5} xsHidden>
      <div className='contact-infos'>
        <h4 className='contact-subtitle-1'><i className='fa fa-map'></i>&nbsp;   {isSpanish === true ? 'Dirección' : 'Address'}</h4>
        {/* <p>308 Garcilaso de la Vega, Arequipa - Peru</p> */}
        <p>Av. Paseo de la República 5181, Lima - Peru</p>
        <h4 className='contact-subtitle-1'><i className='fa fa-phone-square'></i>&nbsp; {isSpanish === true ? 'Teléfono' : 'Phone'}</h4>
        <p>+51 987 248 664</p>
        <h4 className='contact-subtitle-1'><i className='fa fa-envelope'></i>&nbsp; {isSpanish === true ? 'Correo Electrónico' : 'Mail'}</h4>
        <p>sharmynrodriguez@gmail.com</p>
      </div>
    </Col>
  )
}

export const ContactForm = ({ isSpanish }) => {
  return (
    <Col lg={5} md={5} className='contact--form'>
      <h4 className='contact-subtitle-1'><i className='fa fa-paper-plane-o'></i>&nbsp; {isSpanish === true ? 'Envíame un mensaje' : 'Send Me a Message'}</h4>
      <form id='contactForm' method='post' className='form'
        onSubmit={
          e => {
            e.preventDefault()
            addMessage(this.nameRef.value, this.emailRef.value, this.messageRef.value)
            this.nameRef.value = ''
            this.emailRef.value = ''
            this.messageRef.value = ''
          }
        }>
        <div className='form-group'>
          <input className='form-control required' id='name' name='name' placeholder={isSpanish === true ? 'Nombre' : 'Name'} type='text' ref={e => this.nameRef = e} required />
        </div>
        <div className='form-group'>
          <input className='form-control required' id='email' name='email' placeholder={isSpanish === true ? 'Correo Electrónico' : 'Email'} type='email' ref={e => this.emailRef = e} required />
        </div>
        {/* <div className="form-group">
            <input className="form-control required" id="subject" type="text" name="subject" placeholder={isSpanish === true ? 'Tema' : "Subject"} required />
        </div> */}
        <div className='form-group'>
          <textarea className='form-control required' id='message' name='message' placeholder={isSpanish === true ? 'Mensaje' : 'Message'} rows='5' ref={e => this.messageRef = e} required></textarea>
        </div>
        <div className='form-group'>
          <input type='submit' className='btn btn-default form-send' value={isSpanish === true ? '¡Enviar!' : 'Send!'} />
        </div>
      </form>
    </Col>
  )
}

export const ContactIcons = ({ isSpanish }) => {
  return (
    <Col lgHidden mdHidden className='contact-social-icons'>
      <a href='https://github.com/Sharmyn28' target='_blank' rel='noopener noreferrer'><i className='fa fa-github'></i></a>
      <a href='https://www.linkedin.com/in/milagros-rodriguez-coronado/' target='_blank' rel='noopener noreferrer'><i className='fa fa-linkedin'></i></a>
      <a href='https://api.whatsapp.com/send?phone=51987248664&' target='_blank' title='(+51) 987248664' rel='noopener noreferrer'><i className='fa fa-whatsapp'></i></a>
      {isSpanish === true ? <a target='_blank' href={cvespaniol} download='cv-Milagros Rodriguez.pdf' rel='noopener noreferrer'><i className='fa fa-download'></i></a> :
      <a target='_blank' href={resumeenglish} download='resume-Milagros Rodriguez.pdf' rel='noopener noreferrer'><i className='fa fa-download'></i></a>}
    </Col>
  )
}



// WEBPACK FOOTER //
// ./src/components/Contact/Info.js